import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Col, Descriptions, Popconfirm, Row, Tag } from "antd";
import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteDiscountMaster } from "../../redux/actions/discountMaster/deleteDiscountMasterAction";
import { loadSingleDiscountMaster } from "../../redux/actions/discountMaster/detailDiscountMasterAction";
import Loader from "../loader/loader";
import moment from "moment";
import "./discountMaster.css";

const DetailDiscountMaster = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const discount = useSelector((state) => state.discountMasters?.discount);

  useEffect(() => {
    dispatch(loadSingleDiscountMaster(id));
  }, [id, dispatch]);

  const onDelete = () => {
    try {
      dispatch(deleteDiscountMaster(id));
      toast.warning("Discount Master deleted");
      return navigate("/discount-master");
    } catch (error) {
      console.log(error.message);
    }
  };

  const isLogged = Boolean(localStorage.getItem("isLogged"));
  if (!isLogged) {
    return <Navigate to="/auth/login" replace />;
  }

  const getDiscountTypeColor = (type) => {
    const colors = { sale: "green", purchase: "blue" };
    return colors[(type || "").toLowerCase()] || "default";
  };

  return (
    <div className="disc-detail-page">
      <div className="pcat-detail-wrap">
        {discount ? (
          <Fragment key={discount.id}>
            <Card bordered={false} className="disc-detail-card">
              <div className="disc-detail-header">
                <h5 className="disc-detail-title">
                  <i className="bi bi-tag-fill" aria-hidden />
                  <span className="disc-detail-name">Discount Master Details</span>
                </h5>
                <div className="disc-detail-actions">
                  <Link
                    to={`/discount-master/${discount.id}/update`}
                    state={{ data: discount }}>
                    <Button type="primary" shape="round" icon={<EditOutlined />} aria-label="Edit">
                      Edit
                    </Button>
                  </Link>
                  <Popconfirm
                    title="Delete discount"
                    description="Are you sure you want to delete this discount?"
                    onConfirm={onDelete}
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{ danger: true }}>
                    <Button type="danger" shape="round" icon={<DeleteOutlined />} aria-label="Delete">
                      Delete
                    </Button>
                  </Popconfirm>
                </div>
              </div>
              <div className="disc-detail-body">
                <Row>
                  <Col xs={24} xl={14}>
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Discount Type">
                        <Tag color={getDiscountTypeColor(discount.discount_type)}>
                          {(discount.discount_type || "").toUpperCase()}
                        </Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Publisher">
                        {discount.publisher?.name || "—"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Customer">
                        {discount.customer?.name ?? (discount.discount_type === "sale" ? "—" : "—")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Supplier">
                        {discount.supplier?.name ?? (discount.discount_type === "purchase" ? "—" : "—")}
                      </Descriptions.Item>
                      <Descriptions.Item label="Discount Value">
                        {discount.discount_unit === "percentage"
                          ? `${discount.discount_value}%`
                          : `₹${discount.discount_value}`}
                      </Descriptions.Item>
                      <Descriptions.Item label="Discount Unit">
                        <Tag>{discount.discount_unit || "—"}</Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Status">
                        <Tag color={discount.status ? "green" : "red"}>
                          {discount.status ? "Active" : "Inactive"}
                        </Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Effective From">
                        {discount.effective_from
                          ? moment(discount.effective_from).format("ll")
                          : "No limit"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Effective To">
                        {discount.effective_to
                          ? moment(discount.effective_to).format("ll")
                          : "No limit"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Description">
                        {discount.description || "—"}
                      </Descriptions.Item>
                    
                    </Descriptions>
                  </Col>
                </Row>
              </div>
            </Card>
          </Fragment>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default DetailDiscountMaster;
